/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/
export default function Somos() {
  return (
    <div className="relative overflow-hidden bg-white py-16 text-left bg-gray-100">
      <div className="hidden lg:absolute lg:inset-y-0 lg:block lg:h-full lg:w-full lg:[overflow-anchor:none]">
        <div
          className="relative mx-auto h-full max-w-prose text-lg"
          aria-hidden="true"
        >
          <svg
            className="absolute top-12 left-full translate-x-32 transform"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            className="absolute top-1/2 right-full -translate-y-1/2 -translate-x-32 transform"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            className="absolute bottom-12 left-full translate-x-32 transform"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </div>
      </div>
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-prose text-lg text-left">
          <h1>
            {/* <span className="block text-center text-lg font-semibold text-indigo-600">Introducing</span> */}
            <span className="mt-2 block text-left text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              ¿Quiénes somos?
            </span>
          </h1>
          <p className="mt-8 text-xl leading-8 text-gray-500">
            <strong>Cryptonikas Dao es un Proyecto Web3</strong> liderado por
            mujeres, para quienes quieran aprender e incursionar en la
            tecnología blockchain. Con nuestra experiencia y conocimientos
            queremos educar e informar a la comunidad hispanohablante sobre
            Web3. Entendemos los desafíos que tienen la mujer y no binaries en
            el mundo tech y es por eso que queremos compartir el mensaje de que
            todxs podemos ser parte de este mundo sin necesidad de tener o
            poseer un título en específico.
          </p>
        </div>
        <div className="prose prose-lg prose-indigo mx-auto mt-6 text-gray-500 text-left">
          <h2>Los problemas que vemos</h2>
          <p>
            Una de las cosas que nos inspiró a formar este equipo fue la poca
            presencia de mujeres en la participación de proyectos desarrollados
            en Web3, de igual manera reconocimos lo desafiante que puede ser
            encontrar tu lugar dentro de este ecosistema y la verdad es que la
            mayoría de las personas no saben por dónde comenzar. Sea que estas
            buscando un trabajo o comenzar tu propio Proyecto en Web3, aún no
            existe una guía con los pasos a seguir y es por eso que desde
            Cryptonikas Dao queremos enseñarte el camino, ¡estamos aquí para
            apoyarte desde el día número 1 hasta el ¡infinito!
          </p>
          <p>Aquí conectamos y aprendemos todxs juntos.</p>
        </div>
        <div className="prose prose-lg prose-indigo mx-auto mt-6 text-gray-500">
          <h2>¿Qué estamos construyendo?</h2>
          <p>
            A través de nuestras experiencias y conocimientos, al igual que la
            participación de otros expertos en temas más específicos, nos
            mantenemos constantemente educando e informando a la comunidad de
            hispanohablantes sobre conceptos, características, funcionamiento,
            desarrollo, estrategias, noticias actuales y entre otros temas
            relacionados a la Web3.
          </p>
          <p>
            Con la creación de nuestro primer token, queremos brindarle la
            oportunidad a la comunidad de pertenecer a un club exclusivo de
            educación donde se ofrecerán clases y/o charlas sobre Web3, y se
            discutirán las inquietudes y necesidades de los participantes. Estas
            clases van desde cómo lanzar tu propia colección de NFT hasta temas
            de seguridad y privacidad.
          </p>
          <p>
            De igual manera, al abrir nuestro canal de holders (poseedores del
            token) queremos ofrecerles información sobre nuevos proyectos,
            participación en rifas para poder obtener el derecho a comprar
            ciertos proyectos y brindar asesoría en casos de dudas o de
            necesitar consejos.
          </p>
          <p>
            <strong>Cryptonikas Dao</strong> tiene otros planes en desarrollo,
            como por ejemplo la segunda colección de pfp (picture for proof) y
            con ello la conformación de la DAO; igualmente queremos en un futuro
            transformar ese pfp a un avatar que sirva como tu identidad virtual
            en el metaverso.
          </p>
          <p>
            <italic>
              Tenemos muchas ideas que se están empezando a planear…
            </italic>
          </p>
          <p></p>
        </div>
        <div className="prose prose-lg prose-indigo mx-auto mt-6 text-gray-500">
          <h2>Nuestra Audiencia Target</h2>
          <p>
            Nuestro público son las mujeres y no binarios, por ser parte de
            nuestra misión y visión de involucrarlos en el desarrollo y uso de
            nuevas tecnologías. Mas, sin embargo, esto no excluye cualquier otra
            persona dentro o fuera de la industria tecnológica con ganas de
            aprender nuevas habilidades. Todxs están invitados a la nave
            ¡Cryptonika!
          </p>
          <p>
            <strong>El Arte</strong>
          </p>
          <p>¡Sorpresa! 😄</p>
          <p>
            <strong>Nuestro Equipo</strong>
          </p>

          <p>
            <strong>
              Gi — Full Stack Developer. Project Director. Twitter @Gi_chacon
            </strong>
          </p>
          <p>
            Años de experiencia en el mundo tecnológico, desarrolladora y
            programadora especialista en proyectos Web3.
          </p>

          <p>
            <strong>Soho — Creative Project Manager. Twitter @Sohobiit</strong>
          </p>
          <p>
            Artista con años de experiencia en la creación de videojuegos en 2D
            y 3D. Diseñadora Senior. Especialista en Marketing Digital.
          </p>

          <p>
            <strong>
              Rosa — Business & Strategy. Project Manager. Twitter @cryptotonga1
            </strong>
          </p>
          <p>
            Abogada con experiencia en el manejo de proyectos legales para
            empresas y persona natural.
          </p>

          <p>
            <strong>Joe — Designer. Creative. Marketer. Twitter @Joitac</strong>
          </p>
          <p>
            Años de experiencia en diseño, dirección creativa y producción de
            distintas compañías en Latinoamérica, experta en marketing digital.
          </p>

          <p>
            <strong>
              Ambs –Designer. Editor. Community Builder. Twitter @ambaaaaaaar
            </strong>
          </p>
          <p>
            Años de experiencia en el diseño gráfico y como social media manager
            brindando apoyo y aporte a las comunidades.
          </p>

          <p>
            <strong>
              Nairobi — Community Builder. Finance. Twitter @ms_nairobi
            </strong>
          </p>
          <p>
            Años de experiencia como especialista en administración de negocios
            y procesos logísticos.
          </p>

          <p>
            <strong>
              Rach — Content Creator and Curator. Podcast Producer. Twitter @
              Rachel Almonte _
            </strong>
          </p>
          <p>
            Años de experiencia en el manejo de las redes, creación de
            contenido, producción y edición de podcast.
          </p>

          <p>
            <strong>
              Genializa — Content Creator and Writer Analyst. Twitter
              @maria_eliza06
            </strong>
          </p>
          <p>
            Egresada de Relaciones Internacionales, con experiencia en análisis
            y redacción de contenido educativo y para redes sociales.
          </p>
        </div>
      </div>
    </div>
  );
}
